import { AlertSeverityEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Tooltip } from '@mui/material';
import SingleButton from '../SingleButton';
import copy from 'copy-to-clipboard';


interface CopyTextOnClickComponentProps {
  copyText: string;

  label?: string;
  text?: string;
  isButton?: boolean;
  tieneContrato?: boolean;
}

const CopyTextOnClickComponent = ({ copyText, isButton = false, label = 'Copiar' }: CopyTextOnClickComponentProps) => {
  const setAlert = useUiStore(s => s.setAlert);

  const copyToClipboard = async () => {

    if (!copyText)
      return setAlert(true, '¡No hay enlace para copiar, comunicarse con soporte!', AlertSeverityEnum.error);

    //const url = `${VITE_API_URL_OFICINA_VIRTUAL}ver-contrato/${idPreventa}`

    const success = copy(copyText);
    if (success) {
      setAlert(true, '¡Copiado en portapapeles!', AlertSeverityEnum.success);
    } else {
      setAlert(true, 'Error al copiar el texto', AlertSeverityEnum.error);
    }

  };


  if (isButton)
    return (
      <SingleButton
        onClick={copyToClipboard}
        startIcon={<ContentCopyIcon />}
        variant='text'
        label={label}
      />);


  return (
    <Tooltip title='Copiar' placement='top'>
      <IconButton onClick={() => {
        copyToClipboard()
      }}>
        <ContentCopyIcon />
      </IconButton>
    </Tooltip>
  )
};

export default CopyTextOnClickComponent;